// extracted by mini-css-extract-plugin
export default {"appWrapper":"routes_appWrapper__3rrt7","app":"routes_app__LWaRx","notFoundText":"routes_notFoundText__-1ztG"};